export const messages = {
  en: {
    nav: {
      services: "Services",
      industries: "Industries",
      about: "About",
      careers: "Careers",
      enquire: "Enquire",
      homeAria: "AM Global home",
      language: "Language",
    },
    hero: {
      eyebrow: "Licensed in the UAE and the United States",
      headline: "Workforce solutions for the GCC, delivered from Dubai",
      lead:
        "Contract labour, mobilisation, and payroll for employers across the UAE and GCC, with a Dubai talent hub supporting hiring in North America and Europe.",
      speak: "Speak with our team",
      explore: "Explore opportunities",
      proofAria: "Operating footprint",
      licensedUae: "UAE licensed",
      licensedUs: "United States licensed",
      hqDubai: "Headquartered in Dubai",
    },
    paths: {
      eyebrow: "How we can help",
      heading: "Employers and candidates, served with the same operating standard",
      employers: "Employers",
      employersHead:
        "A licensed workforce partner for GCC operations and Western hiring",
      employersBody:
        "Contract labour, visas, and WPS-aligned payroll for UAE and GCC employers, with Dubai-based recruitment support for teams in North America and Europe.",
      viewServices: "View our services",
      candidates: "Candidates",
      candidatesHead: "Structured placements with a licensed employer partner",
      candidatesBody:
        "Roles across the region and through our Dubai talent hub, with a clear path from application to onboarding.",
      submitCv: "Submit your CV",
    },
    how: {
      eyebrow: "Delivery",
      headBefore: "How we ",
      headAccent: "deliver",
      lead:
        "A defined path from first conversation to ongoing workforce support for GCC contract labour and hub-supported hiring in Western markets.",
      steps: [
        {
          step: "01",
          title: "Requirement",
          body: "Share roles, locations, timelines, and constraints. We confirm scope before mobilisation.",
        },
        {
          step: "02",
          title: "Selection and mobilisation",
          body: "We screen, shortlist, and deploy the right people for temporary or longer-term assignments.",
        },
        {
          step: "03",
          title: "Visas and payroll",
          body: "Documentation, government liaison, and WPS-aligned payroll are handled as part of delivery.",
        },
        {
          step: "04",
          title: "Ongoing support",
          body: "One accountable team remains with you for replacements, HR follow-up, and continuity of cover.",
        },
      ],
    },
    services: {
      heading: "Workforce and talent solutions",
      lead:
        "Staffing, recruitment, payroll, and HR support matched to industry, geography, and operating requirement.",
      enquire: "Enquire about this service",
      more: "Read more",
      less: "Show less",
      items: {
        manpower: {
          title: "Manpower Supply",
          para: "Reliable contract and project workforce for UAE and GCC operations, from short-term cover to longer placements.",
          detail:
            "We supply screened manpower so operations continue without gaps, with mobilisation handled as part of the engagement.",
        },
        recruitment: {
          title: "Recruitment Services",
          para: "Structured search and shortlisting for temporary and full-time roles, aligned to role, location, and timeline.",
          detail:
            "We screen and present candidates for GCC employers and for Western teams hiring through the Dubai talent hub.",
        },
        hr: {
          title: "HR Outsourcing",
          para: "Day-to-day HR administration, including visas, benefits, and employee support, delivered under one accountable team.",
          detail:
            "We administer the operational HR load so your managers can remain focused on core business work.",
        },
        payroll: {
          title: "Payroll Services",
          para: "WPS-aligned payroll processing, payslips, and reporting, delivered with the same team that mobilises the workforce.",
          detail:
            "Bespoke payroll cycles reduce operational risk and remove repetitive processing from your finance team.",
        },
        pro: {
          title: "PRO Services",
          para: "Government and compliance liaison, including documentation, filings, and follow-up, managed end to end.",
          detail:
            "We coordinate the required processes so your organisation remains audit-ready without maintaining a separate PRO desk.",
        },
        it: {
          title: "IT Staffing",
          para: "IT staffing across the Gulf, South Asia, and the United States, for short-term, long-term, and project assignments.",
          detail:
            "Developers, analysts, and support specialists are deployed through the Dubai hub to the length and scope required.",
        },
      },
    },
    industries: {
      heading: "Industries we serve",
      lead:
        "Sectors in which we place people for UAE and GCC employers, and through our Dubai talent hub for North America and Europe.",
      enquire: "Enquire about this sector",
      items: {
        automation: {
          label: "Automation",
          blurb:
            "Technicians and operators for production lines, maintenance windows, and plant scale-ups.",
        },
        aviation: {
          label: "Aviation",
          blurb:
            "Ground and support roles that keep airside and terminal operations staffed without gaps.",
        },
        finance: {
          label: "Finance & banking",
          blurb:
            "Admin, operations, and specialised support for institutions that need reliable coverage.",
        },
        food: {
          label: "Food industry",
          blurb:
            "Kitchen, production, and warehouse teams for hospitality and food manufacturing peaks.",
        },
        marine: {
          label: "Marine & shipping",
          blurb:
            "Port, yard, and logistics manpower for vessel turnaround and cargo throughput.",
        },
        energy: {
          label: "Oil & gas / energy",
          blurb:
            "Site and facilities workforce for energy operators with strict compliance needs.",
        },
        tech: {
          label: "Technology & IT",
          blurb:
            "Developers, analysts, and support specialists via the Dubai hub for project-based teams.",
        },
      },
    },
    why: {
      headBefore: "Why ",
      headAccent: "AM Global",
      lead:
        "Five operating reasons for employers who need more than a recruiter, and more attention than an enterprise-scale supplier typically provides.",
      listAria: "Reasons to choose AM Global",
      enquire: "Enquire",
      mediaAlt: "AM Global leadership and operations",
      pillars: [
        {
          title: "Two-jurisdiction trust",
          body: "UAE and US licences under one partner — cross-border hiring without juggling two vendors and two contracts.",
        },
        {
          title: "Dubai hub for Western employers",
          body: "A Dubai talent and delivery hub for mid-to-large firms in North America and Europe.",
        },
        {
          title: "GCC labour, operated for you",
          body: "Visas, WPS-aligned payroll, mobilisation, and ongoing support — operations owned, not only headcount supplied.",
        },
        {
          title: "Senior attention at mid-market scale",
          body: "Reachable decision-makers and bespoke setups — built for companies that get lost inside enterprise-scale suppliers.",
        },
        {
          title: "Value for clients and workers",
          body: "Fair treatment and retention as a quality lever: stable teams perform better for your business.",
        },
      ],
    },
    about: {
      partnerHead: "One partner for GCC labour and Western talent needs",
      partnerBody:
        "AM Global serves UAE and GCC employers who require contract labour they can trust, and companies in North America and Europe who need a Dubai talent hub, under one licensed, accountable team.",
      mediaAlt: "AM Global HR consulting team collaborating",
      storyEyebrow: "From the UAE to San Jose",
      whoHead: "About AM Global",
      whoBody:
        "Founded in the UAE in 2021 and opened for business in 2022, we registered in the United States the same year. From Dubai we recruit, place, and support people for clients, covering applicants, temporary and full-time staff, visas, salary, benefits, and related HR services across the UAE and GCC and into North America and Europe.",
      licensedLine: "Licensed to operate in the UAE and the United States.",
      requestLicence: "Request licence details",
      footprintAria: "Our operating footprint",
      footprintTitle: "Our operating footprint",
      uaeTitle: "UAE & GCC",
      uaeBody:
        "Mobilise local workforce, run WPS-aligned payroll, and stay compliant on the ground.",
      hubTitle: "Dubai talent hub",
      hubBody:
        "Centralise recruitment, screening, and HR delivery for clients across markets.",
      westTitle: "North America & Europe",
      westBody:
        "Support growing teams with flexible talent and staffing coverage through the hub.",
      ctaEyebrow: "One partner. Two markets.",
      ctaHead: "GCC labour and Western talent, under one accountable team",
      ctaBody:
        "Tell us whether you need contract labour across the UAE and GCC, or hub-supported hiring for North America and Europe, and we will structure delivery around that requirement.",
      ctaBtn: "Speak with our team",
    },
    impact: {
      headBefore: "At a ",
      headAccent: "glance",
      lead:
        "Placed headcount, signed contracts, annualised run-rate, and licensed markets across the UAE and the United States since inception.",
      headcount: "Placed headcount",
      contracts: "Signed contracts",
      runRate: "USD M+ run rate",
      markets: "Licensed markets",
    },
    proof: {
      eyebrow: "How we operate",
      headBefore: "Delivery ",
      headAccent: "standards",
      lead:
        "Dual licensing, payroll as part of the engagement, and hub coverage for Western teams.",
      items: [
        {
          title: "Cross-border under one partner",
          body: "UAE and US licensing so mid-market employers do not split hiring across two vendors.",
        },
        {
          title: "Payroll as part of delivery",
          body: "WPS-aligned payroll cycles run with the same team that mobilises and supports the workforce.",
        },
        {
          title: "Hub coverage for Western teams",
          body: "Dubai-based recruitment and HR support for North America and Europe growth needs.",
        },
      ],
    },
    contact: {
      title: "Enquire",
      sentTitle: "Message sent",
      sentBody: "Thank you. We have received your message and will get back to you soon.",
      fixFields: "Please fix the fields below.",
      genericError: "Something went wrong. Please try again later.",
      failed: "Submission failed.",
      name: "Name",
      company: "Company Name",
      email: "Email",
      mobile: "Mobile",
      subject: "Subject",
      message: "How can we help you",
      submit: "Submit",
      processing: "Processing...",
      errors: {
        nameRequired: "Name is required.",
        nameLong: "Name is too long.",
        companyRequired: "Company name is required.",
        companyLong: "Company name is too long.",
        emailRequired: "Email is required.",
        emailInvalid: "Enter a valid email.",
        mobileRequired: "Mobile is required.",
        mobileInvalid:
          "Use 8–24 characters: digits, spaces, +, parentheses, or hyphens.",
        subjectRequired: "Subject is required.",
        subjectLong: "Subject is too long.",
        messageRequired: "Please tell us how we can help.",
        messageLong: "Message is too long (max 8000 characters).",
      },
    },
    footer: {
      dubai: "Dubai",
      us: "US",
      jafza: "JAFZA",
      social: "Social Media",
      about: "About",
      enquire: "Enquire",
      help: "Help",
      privacy: "Privacy Policy",
      disclaimer: "Disclaimer",
      copyright: "Copyright © 2026 • AM GLOBAL",
    },
  },
  ar: {
    nav: {
      services: "الخدمات",
      industries: "القطاعات",
      about: "من نحن",
      careers: "الوظائف",
      enquire: "تواصل معنا",
      homeAria: "الصفحة الرئيسية لإيه إم جلوبال",
      language: "اللغة",
    },
    hero: {
      eyebrow: "مرخّصون في دولة الإمارات والولايات المتحدة",
      headline: "حلول القوى العاملة لدول الخليج، انطلاقاً من دبي",
      lead:
        "عمالة تعاقدية وتعيين وكشوف رواتب لأصحاب العمل في الإمارات ودول الخليج، مع مركز مواهب في دبي يدعم التوظيف في أمريكا الشمالية وأوروبا.",
      speak: "تحدث إلى فريقنا",
      explore: "استكشف الفرص",
      proofAria: "نطاق العمل",
      licensedUae: "ترخيص إماراتي",
      licensedUs: "ترخيص أمريكي",
      hqDubai: "المقر في دبي",
    },
    paths: {
      eyebrow: "كيف يمكننا المساعدة",
      heading: "أصحاب العمل والمرشحون، وفق معيار تشغيلي واحد",
      employers: "أصحاب العمل",
      employersHead:
        "شريك مرخّص للقوى العاملة في عمليات الخليج والتوظيف الغربي",
      employersBody:
        "عمالة تعاقدية وتأشيرات وكشوف رواتب متوافقة مع نظام حماية الأجور لأصحاب العمل في الإمارات ودول الخليج، مع دعم توظيف من دبي لفرق أمريكا الشمالية وأوروبا.",
      viewServices: "اطّلع على خدماتنا",
      candidates: "المرشحون",
      candidatesHead: "توظيف منظّم مع شريك عمل مرخّص",
      candidatesBody:
        "فرص في المنطقة وعبر مركز المواهب في دبي، مع مسار واضح من التقديم إلى مباشرة العمل.",
      submitCv: "قدّم سيرتك الذاتية",
    },
    how: {
      eyebrow: "التنفيذ",
      headBefore: "كيف ",
      headAccent: "ننفّذ",
      lead:
        "مسار واضح من أول تواصل إلى الدعم المستمر للقوى العاملة، سواء للعمالة التعاقدية في الخليج أو التوظيف عبر المركز للأسواق الغربية.",
      steps: [
        {
          step: "01",
          title: "الاحتياج",
          body: "شاركونا الأدوار والمواقع والجداول والقيود. نثبّت النطاق قبل التحريك.",
        },
        {
          step: "02",
          title: "الاختيار والتحريك",
          body: "نفرز ونرشّح وننشر الأشخاص المناسبين للتعيينات المؤقتة أو الأطول أجلاً.",
        },
        {
          step: "03",
          title: "التأشيرات والرواتب",
          body: "الوثائق والتنسيق الحكومي وكشوف الرواتب المتوافقة مع نظام حماية الأجور تُدار ضمن التسليم.",
        },
        {
          step: "04",
          title: "الدعم المستمر",
          body: "فريق واحد يبقى معكم للبدائل ومتابعة الموارد البشرية واستمرارية التغطية.",
        },
      ],
    },
    services: {
      heading: "حلول القوى العاملة والمواهب",
      lead:
        "توظيف واستقطاب ورواتب ودعم موارد بشرية بما يلائم القطاع والجغرافيا ومتطلبات التشغيل.",
      enquire: "استفسر عن هذه الخدمة",
      more: "اقرأ المزيد",
      less: "عرض أقل",
      items: {
        manpower: {
          title: "توريد القوى العاملة",
          para: "قوى عاملة تعاقدية ومشاريع موثوقة لعمليات الإمارات ودول الخليج، من التغطية القصيرة إلى التعيينات الأطول.",
          detail:
            "نوفّر عمالة مفروزة حتى تستمر العمليات دون فجوات، مع إدارة التحريك ضمن التعاقد.",
        },
        recruitment: {
          title: "خدمات الاستقطاب",
          para: "بحث وترشيح منظّم للأدوار المؤقتة والدائمة، وفق الدور والموقع والجدول الزمني.",
          detail:
            "نفرز ونقدّم المرشحين لأصحاب العمل في الخليج وللفرق الغربية التي توظّف عبر مركز دبي.",
        },
        hr: {
          title: "الاستعانة بموارد بشرية خارجية",
          para: "إدارة يومية للموارد البشرية تشمل التأشيرات والمزايا ودعم الموظفين، تحت فريق واحد مسؤول.",
          detail:
            "نتولى العبء التشغيلي للموارد البشرية ليبقى المديرون مركزين على العمل الأساسي.",
        },
        payroll: {
          title: "خدمات الرواتب",
          para: "معالجة رواتب متوافقة مع نظام حماية الأجور وكشوف وتقارير، مع الفريق نفسه الذي يحرّك القوى العاملة.",
          detail:
            "دورات رواتب مخصّصة تقلّل المخاطر التشغيلية وتُريح المالية من المعالجة المتكررة.",
        },
        pro: {
          title: "خدمات المندوب الحكومي",
          para: "التنسيق الحكومي والامتثال، بما في ذلك الوثائق والتقديم والمتابعة، من البداية إلى النهاية.",
          detail:
            "ندير الإجراءات المطلوبة لتبقى المؤسسة جاهزة للتدقيق دون مكتب منفصل للمندوب الحكومي.",
        },
        it: {
          title: "توظيف تقنية المعلومات",
          para: "توظيف تقني عبر الخليج وجنوب آسيا والولايات المتحدة، للتعيينات القصيرة والطويلة والمشاريع.",
          detail:
            "يُنشر المطوّرون والمحللون وأخصائيو الدعم عبر مركز دبي وفق المدة والنطاق المطلوبين.",
        },
      },
    },
    industries: {
      heading: "القطاعات التي نخدمها",
      lead:
        "قطاعات نوظّف فيها للكيانات في الإمارات ودول الخليج، وعبر مركز المواهب في دبي لأمريكا الشمالية وأوروبا.",
      enquire: "استفسر عن هذا القطاع",
      items: {
        automation: {
          label: "الأتمتة",
          blurb: "فنيون ومشغّلون لخطوط الإنتاج ونوافذ الصيانة وتوسيع المصانع.",
        },
        aviation: {
          label: "الطيران",
          blurb: "أدوار أرضية ودعم تُبقي عمليات المطار والمحطات مغطاة دون فجوات.",
        },
        finance: {
          label: "المالية والمصارف",
          blurb: "دعم إداري وتشغيلي ومتخصص للمؤسسات التي تحتاج تغطية موثوقة.",
        },
        food: {
          label: "الصناعات الغذائية",
          blurb: "فرق مطابخ وإنتاج ومستودعات لذروات الضيافة وتصنيع الأغذية.",
        },
        marine: {
          label: "البحرية والشحن",
          blurb: "عمالة الموانئ والساحات واللوجستيات لمناولة السفن وحركة البضائع.",
        },
        energy: {
          label: "النفط والغاز / الطاقة",
          blurb: "قوى عاملة للمواقع والمنشآت لمشغّلي الطاقة ذوي متطلبات الامتثال الصارمة.",
        },
        tech: {
          label: "التقنية وتقنية المعلومات",
          blurb: "مطوّرون ومحللون وأخصائيو دعم عبر مركز دبي لفرق المشاريع.",
        },
      },
    },
    why: {
      headBefore: "لماذا ",
      headAccent: "إيه إم جلوبال",
      lead:
        "خمسة أسباب تشغيلية لأصحاب العمل الذين يحتاجون أكثر من شركة استقطاب، واهتماماً أكبر مما يقدّمه عادةً مورّد بحجم المؤسسات الكبرى.",
      listAria: "أسباب اختيار إيه إم جلوبال",
      enquire: "تواصل معنا",
      mediaAlt: "قيادة وعمليات إيه إم جلوبال",
      pillars: [
        {
          title: "ثقة مزدوجة الاختصاص",
          body: "تراخيص إماراتية وأمريكية تحت شريك واحد، دون إدارة مورّدين وعقدين للتوظيف عبر الحدود.",
        },
        {
          title: "مركز دبي لأصحاب العمل الغربيين",
          body: "مركز مواهب وتنفيذ في دبي للشركات المتوسطة والكبيرة في أمريكا الشمالية وأوروبا.",
        },
        {
          title: "عمالة الخليج تُدار لكم",
          body: "تأشيرات ورواتب متوافقة مع نظام حماية الأجور وتحريك ودعم مستمر: تشغيل كامل وليس مجرد توريد أعداد.",
        },
        {
          title: "اهتمام إداري على نطاق متوسط",
          body: "صانعو قرار يمكن الوصول إليهم وترتيبات مخصّصة، للشركات التي تضيع داخل المورّدين الكبار.",
        },
        {
          title: "قيمة للعملاء والعاملين",
          body: "المعاملة العادلة والاستبقاء رافعة للجودة: الفرق المستقرة تؤدّي بشكل أفضل لأعمالكم.",
        },
      ],
    },
    about: {
      partnerHead: "شريك واحد لاحتياج عمالة الخليج والمواهب الغربية",
      partnerBody:
        "تخدم إيه إم جلوبال أصحاب العمل في الإمارات ودول الخليج ممن يحتاجون عمالة تعاقدية موثوقة، والشركات في أمريكا الشمالية وأوروبا التي تحتاج مركز مواهب في دبي، تحت فريق مرخّص ومسؤول واحد.",
      mediaAlt: "فريق استشارات الموارد البشرية في إيه إم جلوبال",
      storyEyebrow: "من الإمارات إلى سان خوسيه",
      whoHead: "عن إيه إم جلوبال",
      whoBody:
        "تأسست في دولة الإمارات عام 2021 وبدأت أعمالها عام 2022، وسُجّلت في الولايات المتحدة في العام نفسه. من دبي نستقطب ونوظّف وندعم الكوادر للعملاء، بما يغطي المتقدمين والموظفين المؤقتين والدائمين والتأشيرات والرواتب والمزايا وخدمات الموارد البشرية ذات الصلة عبر الإمارات ودول الخليج وصولاً إلى أمريكا الشمالية وأوروبا.",
      licensedLine: "مرخّصون للعمل في دولة الإمارات والولايات المتحدة.",
      requestLicence: "اطلب تفاصيل الترخيص",
      footprintAria: "نطاق عملنا",
      footprintTitle: "نطاق عملنا",
      uaeTitle: "الإمارات ودول الخليج",
      uaeBody:
        "تحريك القوى العاملة المحلية، وتشغيل رواتب متوافقة مع نظام حماية الأجور، والبقاء ملتزمين على الأرض.",
      hubTitle: "مركز المواهب في دبي",
      hubBody:
        "مركزة الاستقطاب والفرز وتسليم الموارد البشرية للعملاء عبر الأسواق.",
      westTitle: "أمريكا الشمالية وأوروبا",
      westBody:
        "دعم الفرق المتنامية بتغطية مرنة للمواهب والتوظيف عبر المركز.",
      ctaEyebrow: "شريك واحد. سوقان.",
      ctaHead: "عمالة الخليج والمواهب الغربية تحت فريق واحد مسؤول",
      ctaBody:
        "أخبرونا إن كنتم تحتاجون عمالة تعاقدية عبر الإمارات ودول الخليج، أو توظيفاً مدعوماً بالمركز لأمريكا الشمالية وأوروبا، وسنبني التسليم حول ذلك الاحتياج.",
      ctaBtn: "تحدث إلى فريقنا",
    },
    impact: {
      headBefore: "في ",
      headAccent: "لمحة",
      lead:
        "أعداد التوظيف والعقود الموقّعة ومعدل التشغيل السنوي والأسواق المرخّصة عبر الإمارات والولايات المتحدة منذ التأسيس.",
      headcount: "الكوادر الموظّفة",
      contracts: "العقود الموقّعة",
      runRate: "معدل تشغيل سنوي (مليون دولار+)",
      markets: "الأسواق المرخّصة",
    },
    proof: {
      eyebrow: "كيف نعمل",
      headBefore: "معايير ",
      headAccent: "التنفيذ",
      lead:
        "ترخيص مزدوج، وكشوف رواتب ضمن التعاقد، وتغطية المركز للفرق الغربية.",
      items: [
        {
          title: "عبر الحدود تحت شريك واحد",
          body: "ترخيص إماراتي وأمريكي حتى لا يضطر أصحاب العمل المتوسطون إلى تقسيم التوظيف على مورّدين.",
        },
        {
          title: "الرواتب جزء من التسليم",
          body: "دورات رواتب متوافقة مع نظام حماية الأجور يديرها الفريق نفسه الذي يحرّك ويدعم القوى العاملة.",
        },
        {
          title: "تغطية المركز للفرق الغربية",
          body: "استقطاب ودعم موارد بشرية من دبي لاحتياجات النمو في أمريكا الشمالية وأوروبا.",
        },
      ],
    },
    contact: {
      title: "تواصل معنا",
      sentTitle: "تم إرسال الرسالة",
      sentBody: "شكراً لكم. استلمنا رسالتكم وسنعاود التواصل قريباً.",
      fixFields: "يرجى تصحيح الحقول أدناه.",
      genericError: "حدث خطأ. يرجى المحاولة لاحقاً.",
      failed: "تعذّر الإرسال.",
      name: "الاسم",
      company: "اسم الشركة",
      email: "البريد الإلكتروني",
      mobile: "الجوال",
      subject: "الموضوع",
      message: "كيف يمكننا مساعدتكم",
      submit: "إرسال",
      processing: "جاري الإرسال...",
      errors: {
        nameRequired: "الاسم مطلوب.",
        nameLong: "الاسم طويل جداً.",
        companyRequired: "اسم الشركة مطلوب.",
        companyLong: "اسم الشركة طويل جداً.",
        emailRequired: "البريد الإلكتروني مطلوب.",
        emailInvalid: "أدخل بريداً إلكترونياً صالحاً.",
        mobileRequired: "رقم الجوال مطلوب.",
        mobileInvalid: "استخدم 8 إلى 24 خانة: أرقام ومسافات و+ وأقواس أو شرطات.",
        subjectRequired: "الموضوع مطلوب.",
        subjectLong: "الموضوع طويل جداً.",
        messageRequired: "يرجى إخبارنا كيف يمكننا المساعدة.",
        messageLong: "الرسالة طويلة جداً (الحد 8000 حرف).",
      },
    },
    footer: {
      dubai: "دبي",
      us: "الولايات المتحدة",
      jafza: "جافزا",
      social: "وسائل التواصل",
      about: "من نحن",
      enquire: "تواصل معنا",
      help: "المساعدة",
      privacy: "سياسة الخصوصية",
      disclaimer: "إخلاء المسؤولية",
      copyright: "حقوق النشر © 2026 • إيه إم جلوبال",
    },
  },
};
